export const apiErrorMessage = (errorMessages: Array<string>) => {
  let message = null;
  if (errorMessages && errorMessages[0] && errorMessages[0].length > 0) {
    message = errorMessages[0];
  }
  return message;
};
